import PropTypes from "prop-types";

// @mui material components
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { Controller } from "react-hook-form";

// Material Dashboard 2 PRO React components
import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";

import FormField from "../FormField";

function SectionInfo({ control, errors }) {

  const colors = {
    "#F44336": "Rojo",
    "#E91E63": "Rosa",
    "#9C27B0": "Púrpura",
    "#673AB7": "Púrpura Profundo",
    "#3F51B5": "Índigo",
    "#2196F3": "Azul",
    "#03A9F4": "Azul Claro",
    "#00BCD4": "Cian",
    "#009688": "Verde Azulado",
    "#4CAF50": "Verde",
    "#8BC34A": "Verde Claro",
    "#CDDC39": "Lima",
    "#FFEB3B": "Amarillo",
    "#FFC107": "Ámbar",
    "#FF9800": "Naranja",
    "#FF5722": "Naranja Profundo",
    "#795548": "Marrón",
    "#9E9E9E": "Gris",
    "#607D8B": "Gris Azulado",
    "#000000": "Negro",
  };

  return (
    <MDBox>
      <MDTypography variant="h5" mb={3}>
        Sobre la sección
      </MDTypography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                label="Nombre"
                error={!!errors.name}
                helperText={errors.name?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                label="Descripción"
                error={!!errors.description}
                helperText={errors.description?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controller
            name="color"
            control={control}
            render={({ field }) => (
              <FormControl fullWidth variant="outlined" error={!!errors.color}>
                <InputLabel id="color-label">Color</InputLabel>
                <Select
                  {...field}
                  labelId="color-label"
                  label="Color"
                  value={field.value}
                  sx={{ height: 56 }}
                >
                  {Object.entries(colors).map(([key, value]) => (
                    <MenuItem key={key} value={key}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>

                {errors.color && (
                  <MDTypography variant="caption" color="error" ml={2} mt={0.5}>
                    {errors.color.message}
                  </MDTypography>
                )}
              </FormControl>
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controller
            name="order"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                label="Orden"
                error={!!errors.order}
                helperText={errors.order?.message}
              />
            )}
          />
        </Grid>

        {/* <Grid item xs={12} sm={12}>
          <Controller
            name="training"
            control={control}
            render={({ field }) => (
              <FormControl fullWidth variant="outlined" error={!!errors.training}>
                <InputLabel id="training-label">Cursos</InputLabel>
                <Select
                  {...field}
                  multiple
                  labelId="training-label"
                  label="Cursos"
                  value={field.value || []} // Asegura que siempre sea un array
                  onChange={(event) => {
                    const value = event.target.value;
                    // Permite seleccionar/deseleccionar (MUI maneja arrays)
                    field.onChange(typeof value === "string" ? value.split(",") : value);
                  }}
                  // Chips bonitos dentro del select
                  renderValue={(selected) => (
                    <MDBox sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((value) => {
                        const selectedOption = trainingOptions.find(opt => opt.id === value);
                        return (
                          <Chip
                            key={value}
                            label={selectedOption?.name || "Desconocido"}
                            size="small"
                            color="info"
                            sx={{ height: 24, fontSize: "0.8125rem" }}
                          />
                        );
                      })}
                    </MDBox>
                  )}
                  sx={{ height: 56 }} // Mantiene altura consistente con otros campos
                >
                  {trainingOptions.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>

                {errors.training && (
                  <MDTypography variant="caption" color="error" ml={2} mt={0.5}>
                    {errors.training.message}
                  </MDTypography>
                )}
              </FormControl>
            )}
          />
        </Grid> */}
      </Grid>
    </MDBox>
  );
}

SectionInfo.propTypes = {
  control: PropTypes.isRequired,
  errors: PropTypes.isRequired,
};

export default SectionInfo;
